/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * Imprt CSS.
 */
import "swiper/css/bundle";

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function defaultSlider() {
	if (window.matchMedia("(min-width: 600px)").matches) {
		var centeredSlides = false;
	} else {
		var centeredSlides = true;
	}

	const option = {
		loop: true,
		slidesPerView: 1.5,
		speed: 4000, // ループの時間
		allowTouchMove: true,
		autoplay: {
			delay: 0, // 途切れなくループ
		},
		breakpoints: {
			768: {
				slidesPerView: 3.5,
				speed: 5000, // ループの時間
				allowTouchMove: false,
			}
		}
	};

	const slider = new Swiper(".post-slider", option);
}

document.addEventListener("DOMContentLoaded", function() {
    defaultSlider();
});

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: フェードスライダー */

import { fadeSlider } from "./slider/fade/slider-fade-normal";
import { carouselSlider } from "./slider/carousel/slider-carousel";

export { defaultSlider, fadeSlider, carouselSlider };
